import React from "react";

import { FeatureFlagEnum } from "@/features/feature-flag/constants";
import { FeatureGate } from "@/features/feature-flag/components/FeatureGate";

import InsuranceEligibilityV2 from "./InsuranceEligibilityV2/InsuranceEligibilityV2";
import SkipInsuranceEligibility from "./SkipInsuranceEligibility/SkipInsuranceEligibility";

const InsuranceEligibilityWrapper = ({
  accountData,
  eligibilityCallback,
  entryPoint,
  insuranceDetails,
  setEligibilityMessage = () => {},
  setRequiredFields = () => {},
  submissionAttempts,
  ...props
}) => {
  return (
    <FeatureGate
      defaultFlagValue={true}
      disabledFallback={
        <SkipInsuranceEligibility
          eligibilityCallback={eligibilityCallback}
          submissionAttempts={submissionAttempts}
        />
      }
      flagName={FeatureFlagEnum.insuranceEligibilityCheck}
    >
      <InsuranceEligibilityV2
        accountData={accountData}
        eligibilityCallback={eligibilityCallback}
        entryPoint={entryPoint}
        insuranceDetails={insuranceDetails}
        props={props}
        setEligibilityMessage={setEligibilityMessage}
        setRequiredFields={setRequiredFields}
        submissionAttempts={submissionAttempts}
      />
    </FeatureGate>
  );
};

export default InsuranceEligibilityWrapper;
